module.exports = __webpack_public_path__ + "media/bookPage/3-5c72988b.jpeg";